import React from 'react';
import { Paper, Typography, Box } from '@mui/material';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import { Visit } from '../types';

// Fix for default marker icons in React-Leaflet
delete (L.Icon.Default.prototype as any)._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png',
  iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png'
});

interface VisitMapProps {
  visits: Visit[];
}

export const VisitMap: React.FC<VisitMapProps> = ({ visits }) => {
  // Calculate center based on visits or default to a central location
  const center: [number, number] = visits.length > 0
    ? [visits[0].location.latitude, visits[0].location.longitude]
    : [40.7128, -74.0060]; // Default to NYC coordinates

  return (
    <Paper sx={{ 
      height: '100%',
      display: 'flex',
      flexDirection: 'column'
    }}>
      <Box sx={{ p: 2, borderBottom: 1, borderColor: 'divider' }}>
        <Typography variant="h6" component="h2">
          Visit Routes
        </Typography>
      </Box>

      <Box sx={{ 
        flexGrow: 1,
        position: 'relative',
        '.leaflet-container': { 
          height: '100%',
          borderRadius: '0 0 8px 8px'
        } 
      }}>
        <MapContainer
          center={center}
          zoom={12}
          style={{ height: '100%', width: '100%' }}
          zoomControl={true}
          scrollWheelZoom={true}
        >
          <TileLayer
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          />
          {visits.map(visit => (
            <Marker 
              key={visit.id} 
              position={[visit.location.latitude, visit.location.longitude]}
            >
              <Popup>
                <Typography variant="subtitle2">
                  Student ID: {visit.studentId}
                </Typography>
                <Typography variant="body2">
                  {visit.location.address}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Visit Time: {new Date(visit.date).toLocaleTimeString()}
                </Typography>
              </Popup>
            </Marker>
          ))}
        </MapContainer>
      </Box>
    </Paper>
  );
};